import React, { useContext, useState, useEffect } from 'react'
import Layout from '@/product/components/templates/Layout'
import AuthContext from '@/product/context/auth/authContext'
import CommentContext from '@/product/context/comment/commentContext'
import AlertContext from '@/product/context/alert/alertContext'
import { useHistory } from 'react-router-dom'
import { Button, Menu, MenuItem, LinearProgress, AppBar } from '@mui/material'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import PropTypes from 'prop-types'
import { dateTimeFormatFunction } from '@/custom/common/components'
import './Comments.css'
import CustomDialog from '@/product/components/organisms/Dialog'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { mapData } from '@/product/common/components'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import Loaders from '@/product/components/molecules/Loaders'
import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import CommonContext from '@/product/context/common/commonContext'

function TabPanel(props) {
    const { children, value, index, ...other } = props

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <div>
                    <>{children}</>
                </div>
            )}
        </div>
    )
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    }
}

const ManageComments = (props) => {
    const alertContext = useContext(AlertContext)
    const { user } = useContext(AuthContext)
    const dashboardContext = useContext(CommonContext)
    const {
        all_comments,
        getAllComments,
        saveComment,
        all_reply_comments,
        getAllReplyComments,
        responseStatus: replyCommentsResponse,
        clearResponse: clearComment,
    } = useContext(CommentContext)
    const { getMainDashboardData } = dashboardContext

    const history = useHistory()
    const { setAlert } = alertContext

    const toggleFullScreenPopup = props.function

    const [isLoading, setIsLoading] = useState(true)
    const [reload, setReload] = useState(false)
    const [publish, setPublish] = useState(false)
    const [value, setValue] = useState(0)
    const [commentInfo, setCommentInfo] = useState(null)
    const [replyInfo, setReplyInfo] = useState([])
    const [addCommentPopup, setAddCommentPopup] = useState(false)
    const [disable, setDisable] = useState(false)

    const [currentData, setCurrentData] = useState(null)

    let projectId = props?.match?.params?.productId
    let commentId = props?.match?.params?.id

    const handleChange = (newValue) => {
        setValue(newValue)
    }

    const getReplyFunction = () => {
        setIsLoading(true)
        console.log(commentId, 'commthy')
        if (commentId > 0) {
            getAllReplyComments(
                {
                    page: 1,
                    limit: 20,
                    order: '',
                    orderby: '',
                    id: commentId,
                    filters: {
                        comment_id: {
                            value: commentId,
                            type: 'in',
                            field: 'c.comment_id',
                        },
                        status: {
                            value: 1,
                            type: 'in',
                            field: 'c.active',
                        },
                    },
                },
                'insideReplyall'
            )
        }
    }
    useEffect(() => {
        if (commentId) {
            setIsLoading(true)
            getAllComments(
                {
                    page: 1,
                    limit: 20,
                    order: '',
                    orderby: '',
                    id: commentId,
                },
                'insideReply'
            )
        }
    }, [commentId])

    useEffect(() => {
        if (commentId) {
            getReplyFunction()
        }
    }, [commentId])

    useEffect(() => {
        if (all_comments.from === 'insideReply') {
            if (all_comments && all_comments.records.length > 0) {
                setCurrentData(all_comments.records[0])
                setReload(!reload)
            }
            setIsLoading(false)
        }
    }, [all_comments])

    useEffect(() => {
        if (all_reply_comments.from === 'insideReplyall') {
            if (all_reply_comments && all_reply_comments.records.length > 0) {
                setReplyInfo(all_reply_comments.records)
                setReload(!reload)
            } else {
                setReplyInfo([])
            }
        }
        setIsLoading(false)
    }, [all_reply_comments])

    const validationAddComment = Yup.object({
        comment: Yup.string().required('Required'),
    })

    // const [publishComment, setPublishComment] = useState(false)

    const formikAddComment = useFormik({
        initialValues: {
            table: '',
            comment: '',
            comment_id: 0,
            user_id: 0,
            project_id: 0,
            published: false,
        },
        validationSchema: validationAddComment,
        onSubmit: (values) => {
            if (values.comment !== '') {
                formikAddComment.values.table = 'comments'
                formikAddComment.values.user_id = user?.admin_id || 0
                setDisable(true)
                saveComment(values)
                getMainDashboardData()
            }
        },
    })

    const addCommentoption = [
        {
            label: 'Answer',
            placeholder: 'Add a Answer',
            type: 'textarea',
            class: 'col-12',
            name: 'comment',
            rows: '5',
            formik: formikAddComment,
        },
    ]

    useEffect(() => {
        if (
            (replyCommentsResponse?.from === 'saveComment' ||
                replyCommentsResponse?.from === 'publish') &&
            replyCommentsResponse?.status === 'success'
        ) {
            if (replyCommentsResponse?.from === 'publish') {
                setAlert(
                    'Status Successfully changed',
                    replyCommentsResponse.status
                )
            } else {
                setAlert('Commented Successfully', replyCommentsResponse.status)
            }

            formikAddComment.values.comment = ''
            setAddCommentPopup(false)
            getAllComments(
                {
                    page: 1,
                    limit: 20,
                    order: '',
                    orderby: '',
                    id: commentId,
                },
                'insideReply'
            )
            getReplyFunction()
        }
        clearComment()
        setDisable(false)
        setPublish(false)
    }, [replyCommentsResponse])

    const closeFunction = () => {
        setAddCommentPopup(false)
        formikAddComment.values.comment = ''
    }

    const manageAddComment = () => {
        formikAddComment.values.comment_id = commentId
        formikAddComment.values.project_id = projectId
        setAddCommentPopup(true)
    }

    const managePublish = (id, comment_id, publish) => {
        setIsLoading(true)
        setPublish(true)
        console.log(currentData, 'current')
        if (currentData.published) {
            saveComment(
                {
                    id: [id],
                    published: publish ? 1 : 0,
                },
                'publish'
            )
        } else {
            saveComment(
                {
                    id: [id, comment_id],
                    published: publish ? 1 : 0,
                },
                'publish'
            )
        }
    }

    const changeAddCommentPopup = () => {
        setAddCommentPopup(!addCommentPopup)
    }

    return (
        <Layout>
            {isLoading ? (
                <div className="fspLoader">
                    <Loaders isLoading={isLoading} />
                </div>
            ) : (
                <div>
                    <div className="commentsTab">
                        <div className="questionCnt">
                            {/* <h3>Question </h3> */}
                            <div className="questionCntInner">
                                <h6>
                                    <span className="material-icons">
                                        account_circle
                                    </span>
                                    {all_comments?.records[0]?.first_name}{' '}
                                    {all_comments?.records[0]?.last_name}
                                </h6>
                                <h2>{all_comments?.records[0]?.comment} </h2>
                                <div className="d-flex">
                                    {' '}
                                    <p>
                                        <span>Asked on: </span>
                                        {dateTimeFormatFunction(
                                            all_comments?.records[0]?.created_at
                                        )}{' '}
                                    </p>
                                    <p>
                                        <span>Updated on: </span>
                                        {dateTimeFormatFunction(
                                            all_comments?.records[0]?.updated_at
                                        )}{' '}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="repliesCnt">
                            <ul>
                                {replyInfo?.length > 0 &&
                                    replyInfo?.map((data, index) => (
                                        <li>
                                            <div className="rcTop">
                                                <h6>{data.comment}</h6>
                                                {user ? (
                                                    <>
                                                        {data.published ? (
                                                            <Button
                                                                className="unpublishBtn"
                                                                onClick={() =>
                                                                    managePublish(
                                                                        data.id,
                                                                        data.comment_id,
                                                                        false
                                                                    )
                                                                }
                                                                disabled={
                                                                    publish
                                                                }
                                                            >
                                                                Unpublish
                                                            </Button>
                                                        ) : (
                                                            <Button
                                                                className="publishBtn"
                                                                onClick={() =>
                                                                    managePublish(
                                                                        data.id,
                                                                        data.comment_id,
                                                                        true
                                                                    )
                                                                }
                                                                disabled={
                                                                    publish
                                                                }
                                                            >
                                                                Publish
                                                            </Button>
                                                        )}
                                                    </>
                                                ) : null}
                                            </div>
                                            <span>
                                                Updated by:{' '}
                                                {`${data.first_name} ${
                                                    data.last_name
                                                } on ${dateTimeFormatFunction(
                                                    data.updated_at
                                                )}`}
                                            </span>
                                        </li>
                                    ))}
                            </ul>
                        </div>
                        <div className="addReplyCnt">
                            {' '}
                            <Button
                                variant="outlined"
                                onClick={manageAddComment}
                            >
                                {' '}
                                <span className="material-icons">
                                    add_comment
                                </span>
                                Add a reply
                            </Button>
                        </div>
                    </div>
                    <CustomDialog
                        title={'Answer'}
                        open={addCommentPopup}
                        function={changeAddCommentPopup}
                        disableBackdropClick
                        className="commentsModal"
                    >
                        <p>{'Write an answer for this question'}</p>

                        <div className="row">
                            {Object.values(mapData(addCommentoption))}
                        </div>

                        <div className="actionWrapper">
                            <Button
                                id="comment_cancel"
                                onClick={() => closeFunction()}
                            >
                                {'Cancel'}
                            </Button>
                            <PrimaryButton
                                id="comment_submit"
                                onClick={formikAddComment.handleSubmit}
                                type="button"
                                disabled={disable}
                                label={'Submit'}
                            />
                        </div>
                    </CustomDialog>
                </div>
            )}
        </Layout>
    )
}

export default ManageComments
